import React from 'react';
import PropTypes from 'prop-types';

import CheckboxGroup from '../../../../components/molecules/CheckboxGroup';
import SectionHeader from '../../../../components/molecules/SectionHeader/SectionHeader';
import ContentSpacer from '../../../../components/atoms/ContentSpacer';

const ItemSelect = (props) => {
  const {
    sectionName,
    groupName,
    type,
    itemList,
    disabled,
    onChange,
  } = props;

  return (
    <section>
      <SectionHeader value={sectionName} />
      <ContentSpacer>
        <CheckboxGroup
          name={groupName}
          type={type}
          checkboxList={itemList}
          disabled={disabled}
          onChange={onChange}
        />
      </ContentSpacer>
    </section>
  );
};

ItemSelect.propTypes = {
  sectionName: PropTypes.string,
  groupName: PropTypes.string,
  type: PropTypes.oneOf(['checkbox', 'radio', 'switch']),
  itemList: PropTypes.arrayOf(
    PropTypes.object,
  ).isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

ItemSelect.defaultProps = {
  sectionName: '',
  groupName: null,
  type: 'checkbox',
  disabled: false,
  onChange: null,
};

export default ItemSelect;
